/**
 * Вага 1 м.п. (кг) для матеріалу: propertyPairs, інакше typeId.kgPerLinearMeter (клієнт/сервер).
 */

export function kgPerLinearMeterFromMaterialPropertyPairs(propertyPairs) {
    if (!Array.isArray(propertyPairs)) {
        return NaN;
    }
    for (const p of propertyPairs) {
        const kn = String(p.key ?? "")
            .trim()
            .toLowerCase()
            .replace(/\s+/g, " ");
        if (kn !== "вага 1 м.п." && kn !== "вага 1мп") {
            continue;
        }
        const raw = String(p.value ?? "")
            .trim()
            .replace(/\s/g, "")
            .replace(",", ".");
        if (!raw) {
            continue;
        }
        const num = Number(raw);
        if (Number.isFinite(num) && num > 0) {
            return num;
        }
    }
    return NaN;
}

export function effectiveKgPerLinearMeterForMaterial(mat) {
    if (!mat) {
        return NaN;
    }
    const fromPairs = kgPerLinearMeterFromMaterialPropertyPairs(mat.propertyPairs);
    if (Number.isFinite(fromPairs) && fromPairs > 0) {
        return fromPairs;
    }
    const tid = mat.typeId;
    const fromType =
        tid && typeof tid === "object" && tid !== null
            ? Number(tid.kgPerLinearMeter)
            : NaN;
    if (Number.isFinite(fromType) && fromType > 0) {
        return fromType;
    }
    return NaN;
}
